import { createBrowserHistory } from 'history';
const history = createBrowserHistory();
export const HistoryAction = {
  push: 'PUSH',
  pop: 'POP',
  replace: 'REPLACE',
};
export default history;
